import React from 'react';
import styled from 'styled-components';
import { Box, Avatar } from 'theme-ui';
import { BorderProps, border } from 'styled-system';

const OnlineDot = styled.div<{ online: boolean }>`
  border-radius: 50%;
  height: 15px;
  width: 15px;
  min-height: 10px;
  min-width: 10px;
  background-color: ${({ online }) => (online ? '#63A824' : 'red')};
`;

const StyledAvatar = styled(Box)<{ size?: number }>`
  position: relative;
  height: ${({ size }) => size || '100'}px;
  width: ${({ size }) => size || '100'}px;
`;

const ProfileOnlineDot = styled(OnlineDot)<BorderProps & { size?: number }>`
  box-sizing: content-box;
  position: absolute;
  bottom: 0;
  right: 0;
  height: ${({ size }) => (size ? size / 5 : '20')}px;
  width: ${({ size }) => (size ? size / 5 : '20')}px;
  /* z-index: 1; */
  ${border}
`;

ProfileOnlineDot.defaultProps = {
  borderWidth: 3,
  borderStyle: 'solid',
  borderColor: 'background'
};

const ProfileAvatar: React.FC<{
  online: boolean;
  avatar: string;
  size?: number;
}> = ({ avatar, online, size = 100 }) => (
  <StyledAvatar size={size}>
    <Avatar
      src={avatar}
      sx={{
        width: '100%',
        height: '100%',
        borderWidth: 3,
        borderStyle: 'solid',
        borderColor: 'background'
      }}
    />
    <ProfileOnlineDot online={online} size={size} />
  </StyledAvatar>
);

export default ProfileAvatar;
